import { Component, forwardRef, Input, OnInit } from '@angular/core'
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms'
import { UtilsService } from '../../../../services/utils.service'

interface FieldConfigs {
    placeholder?: string
    width?: string
    ngMask?: any
}

@Component({
    selector: 'app-form-input',
    templateUrl: './form-input.component.html',
    styleUrls: ['./form-input.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FormInputComponent),
            multi: true,
        },
    ],
})
export class FormInputComponent implements OnInit, ControlValueAccessor {
    @Input() label = ''
    @Input() hideLabel = false
    @Input() id: string = ''
    @Input() control!: any | null
    @Input() isReadOnly = false
    @Input() isRequired = false
    @Input() fieldType = 'text'
    @Input() fieldConfigs: FieldConfigs = { placeholder: '', ngMask: false }
    @Input() customInputStyle = {}
    @Input() tipText: any = null
    @Input() standAloneForm: boolean = false

    constructor(private readonly utils: UtilsService) {}

    value: any

    public controlName = ''

    ngOnInit(): void {
        this.controlName = this.utils.stringToKebabCase(this.utils.getControlName(this.control) ?? '') + '-input'
    }

    onChanged: (value: any) => void = () => {}

    onTouched: () => void = () => {}

    writeValue(value: any): void {
        this.value = value
    }

    registerOnChange(fn: any): void {
        this.onChanged = fn
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn
    }

    setDisabledState?(isDisabled: boolean): void {
        this.isReadOnly = isDisabled
    }
}
